package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.css.overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.userSelect
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.MyStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.POPPINS
import kotlinx.browser.document
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.events.Event

@Composable
fun CustomDropdown(
    label    : String,
    options  : List<String>,
    selected : String,
    isMobile : Boolean,
    onSelect : (String) -> Unit,
    modifier : Modifier = Modifier
) {
    val colorMode by ColorMode.currentState
    val isDark    = colorMode.isDark

    val textColor   = if (isDark) Colors.White   else Colors.Primary
    val inputBg     = if (isDark) Colors.holder  else Colors.fillbox
    val borderColor = if (isDark) Colors.borders else Colors.lineBorder
    val dropBg      = if (isDark) Colors.DarkBG  else Colors.White
    val selectedBg  = if (isDark) Colors.holder  else Colors.LightGray

    val hoverBg     = Colors.GoubeBlue
    val iconFilter  = if (isDark) "invert(1)"    else "none"

    var open       by remember { mutableStateOf(false) }
    var hoveredIdx by remember { mutableStateOf(-1) }

    DisposableEffect(open) {
        if (!open) return@DisposableEffect onDispose {}
        val handler: (Event) -> Unit = { open = false; hoveredIdx = -1 }
        document.addEventListener("click", handler, true)
        onDispose { document.removeEventListener("click", handler, true) }
    }

    val triggerH = if (isMobile) 44 else 52
    val labelH   = if (isMobile) 22 else 26
    val labelGap = 8
    val panelTop = triggerH + labelH + labelGap

    Column(
        modifier = modifier
            .fillMaxWidth()
            .margin(bottom = if (isMobile) 18.px else 24.px)
            .position(Position.Relative)
    ) {

        SpanText(
            label,
            modifier = Modifier
                .color(textColor)
                .fontSize(if (isMobile) 14.px else 25.px)
                .fontFamily(INTER)
                .fontWeight(FontWeight.SemiBold)
                .margin(bottom = labelGap.px)
                .userSelect(UserSelect.None)
        )

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(triggerH.px)
                .backgroundColor(inputBg)
                .borderRadius(10.px)
                .border(1.px, LineStyle.Solid, if (open) Colors.GoubeBlue else borderColor)
                .padding(leftRight = 14.px)
                .cursor(Cursor.Pointer)
                .userSelect(UserSelect.None)
                .styleModifier { property("transition", "border-color 200ms ease") }
                .onClick { event ->
                    event.stopPropagation()
                    open = !open
                    if (!open) hoveredIdx = -1
                },
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                selected,
                modifier = Modifier
                    .color(if (selected.isEmpty()) Colors.Placeholder else textColor)
                    .fontSize(if (isMobile) 13.px else 15.px)
                    .fontFamily(INTER)
            )
            Spacer()
            Box(
                modifier = Modifier.styleModifier {
                    property("transform",   if (open) "rotate(180deg)" else "rotate(0deg)")
                    property("transition",  "transform 200ms ease")
                    property("display",     "flex")
                    property("align-items", "center")
                }
            ) {
                Image(
                    src = "chevron-down3.svg",
                    modifier = Modifier
                        .width(16.px)
                        .height(16.px)
                        .styleModifier { property("filter", iconFilter) }
                )
            }
        }

        if (open) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .backgroundColor(dropBg)
                    .borderRadius(8.px)
                    .border(1.px, LineStyle.Solid, borderColor)
                    .maxHeight(220.px)
                    .zIndex(100)
                    .position(Position.Absolute)
                    .styleModifier {
                        property("top",        "${panelTop}px")
                        property("left",       "0")
                        property("box-shadow", "0 4px 16px rgba(0,0,0,0.12)")
                        overflow(Overflow.Auto)
                    }
                    .onClick { event -> event.stopPropagation() }
            ) {
                options.forEachIndexed { index, option ->
                    val isSelected = option == selected
                    val isHovered  = index == hoveredIdx
                    val isLast     = index == options.lastIndex

                    val rowBg   = when {
                        isHovered  -> hoverBg
                        isSelected -> selectedBg
                        else       -> dropBg
                    }
                    val rowText = if (isHovered) Colors.White else textColor
                    val rowWeight = if (isSelected && !isHovered) FontWeight.SemiBold else FontWeight.Normal

                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(leftRight = 14.px, topBottom = if (isMobile) 10.px else 13.px)
                            .backgroundColor(rowBg)
                            .cursor(Cursor.Pointer)
                            .userSelect(UserSelect.None)
                            .styleModifier { property("transition", "background-color 120ms ease") }
                            .let { if (!isLast) it.borderBottom(1.px, LineStyle.Solid, borderColor) else it }
                            .onMouseEnter { hoveredIdx = index }
                            .onMouseLeave { hoveredIdx = -1 }
                            .onClick {
                                onSelect(option)
                                open       = false
                                hoveredIdx = -1
                            }
                    ) {
                        SpanText(
                            option,
                            modifier = Modifier
                                .color(rowText)
                                .fontSize(if (isMobile) 13.px else 15.px)
                                .fontFamily(INTER)
                                .fontWeight(rowWeight)
                        )
                    }
                }
            }
        }
    }
}

